import React from 'react';
import { SectionPanel } from 'ui';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { AlertInfo } from 'app/components/alert-info/alert-info';
import { MetroLineSection } from 'app/components/metro-line/metro-line-section';
import { FavouriteSectionType } from '../metroline/types';
import { FavouriteSection } from '../types';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import { CodeMultipleHierarchyPicker, CodeMultiplePicker } from 'app/area/codetable/common';
import { endpoints } from 'app/area/favourite-administration/form/endpoints';
import { CodeComplexValue } from 'app/area/shared/codetable/types';
import { manageOptionsUserGroup } from 'app/area/shared/manage-options';
import { FavouriteFormIds } from 'app/area/favourite-administration/form/constants';
import { iSharedWithVisibleAndEditable } from 'app/area/favourite-administration/form/components/helpers';

export const FavouriteSharedWith: React.FC<FavouriteSection> = ({
  favouriteItem, updateItem, options, loadOptions, validation,
  translation, section, getRef, shouldRenderSection, locale
}) => {

  const onLoadUserGroupOptions = (id: string, loadOptionsParams: LoadOptions) => {
    loadOptions(id, endpoints.sharedWithUserGroups, loadOptionsParams);
  };

  const onLoadUsersOptions = (id: string, loadOptionsParams: LoadOptions) => {
    loadOptions(id, endpoints.sharedWithUsers, loadOptionsParams);
  };

  const onUserGroupChange = (values: ComplexValue<number>[]) => {
    updateItem({ sharedWithUserGroups: values });
  };

  const onUsersChange = (values: ComplexValue<number>[]) => {
    updateItem({ sharedWithUsers: values });
  };

  const extraFooterButton = manageOptionsUserGroup(translation.manage_options);

  const userGroupsOptions = (!!options && !!options.userGroups && options.userGroups.codes || []) as CodeComplexValue<number>[];
  const usersOptions = (!!options && !!options.users && options.users.codes || []) as CodeComplexValue<number>[];

  return <MetroLineSection<FavouriteSectionType>
    section={section}
    sectionType={FavouriteSectionType.SharedWith}
    getRef={getRef}
    shouldRenderSection={shouldRenderSection}>
    <div ref={getRef(FavouriteSectionType.SharedWith)}>
      <SectionPanel
        className="admin-paper-top-panel"
        componentId={FavouriteSectionType.SharedWith}
        validation={undefined}
        info={{ text: translation.shared_with }}
        label={{ visible: true, text: translation.shared_with }} />
      <MainGridContainer>
        <div className="row">
          {iSharedWithVisibleAndEditable(favouriteItem?.favouriteType?.value)
            && <AlertInfo text={translation.shared_with_warning} />}
          <CodeMultipleHierarchyPicker
            id={FavouriteFormIds.userGroups}
            label={translation.shared_with_user_groups}
            valueItems={favouriteItem.sharedWithUserGroups}
            validation={validation?.sharedWithUserGroups}
            locale={locale}
            readOnly={false}
            displaySelectAll={true}
            options={userGroupsOptions}
            fetchingOptions={options && options.userGroups && options.userGroups.fetching}
            translation={translation as any}
            extraFooterButton={extraFooterButton}
            onLoadOptions={onLoadUserGroupOptions}
            onChange={onUserGroupChange} />
          <CodeMultiplePicker
            id={FavouriteFormIds.users}
            label={translation.shared_with_users}
            valueItems={favouriteItem.sharedWithUsers}
            validation={validation?.sharedWithUsers}
            locale={locale}
            readOnly={false}
            displaySelectAll={true}
            options={usersOptions}
            fetchingOptions={options && options.users && options.users.fetching}
            translation={translation as any}
            extraFooterButton={undefined}
            onLoadOptions={onLoadUsersOptions}
            onChange={onUsersChange} />
        </div>
      </MainGridContainer>
    </div>
  </MetroLineSection>;
};
